enum Types {
  GET_ALL_USER_COMPANY_REQUEST = 'GET_ALL_USER_COMPANY_REQUEST',
  GET_ALL_USER_COMPANY_FULFILLED = 'GET_ALL_USER_COMPANY_FULFILLED',
  GET_ALL_USER_COMPANY_REJECTED = 'GET_ALL_USER_COMPANY_REJECTED',

  GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST',
  GET_COMPANY_FULFILLED = 'GET_COMPANY_FULFILLED',
  GET_COMPANY_REJECTED = 'GET_COMPANY_REJECTED',

  GET_ALL_COMPANIES_REQUEST = 'GET_ALL_COMPANIES_REQUEST',
  GET_ALL_COMPANIES_FULFILLED = 'GET_ALL_COMPANIES_FULFILLED',
  GET_ALL_COMPANIES_REJECTED = 'GET_ALL_COMPANIES_REJECTED',

  GET_ALL_COMPANIES_OPERATOR_REQUEST = 'GET_ALL_COMPANIES_OPERATOR_REQUEST',
  GET_ALL_COMPANIES_OPERATOR_FULFILLED = 'GET_ALL_COMPANIES_OPERATOR_FULFILLED',
  GET_ALL_COMPANIES_OPERATOR_REJECTED = 'GET_ALL_COMPANIES_OPERATOR_REJECTED',

  EDIT_COMPANY_NAMES_REQUEST = 'EDIT_COMPANY_NAMES_REQUEST',
  EDIT_COMPANY_NAMES_FULFILLED = 'EDIT_COMPANY_NAMES_FULFILLED',
  EDIT_COMPANY_NAMES_REJECTED = 'EDIT_COMPANY_NAMES_REJECTED',
}

export default Types;
